import React from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
  return (
    <header className="bg-gray-800 text-white p-4 shadow-md">
      <div className="container mx-auto flex justify-between items-center">
        <h1 className="text-2xl font-bold">
          <Link to="/">Learn JavaScript</Link>
        </h1>
        <nav>
          <Link to="/" className="mr-4 hover:text-gray-300">Home</Link>
          <Link to="/articles" className="mr-4 hover:text-gray-300">Articles</Link>
          <Link to="/about" className="hover:text-gray-300">About</Link>
        </nav>
      </div>
    </header>
  );
};

export default Header;
